import { render, staticRenderFns } from "./TableDataTag.vue?vue&type=template&id=6ebd1d63&"
import script from "./TableDataTag.vue?vue&type=script&lang=ts&"
export * from "./TableDataTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports